export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

const SESSION_EXPIRED_MESSAGES = new Set([
  'authentication_required',
  'invalid_or_expired_session',
]);

export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      ...(options.body ? { 'content-type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  if (!response.ok) {
    let message = 'Não foi possível concluir o pedido.';
    try {
      const body = (await response.json()) as { message?: string };
      message = body.message || message;
    } catch {
    }
    if (response.status === 401 && SESSION_EXPIRED_MESSAGES.has(message)) {
      window.dispatchEvent(new Event('qui:session-expired'));
    }
    throw new ApiError(response.status, message);
  }
  return (await response.json()) as T;
}

export function money(amountMinor: number, currency: string) {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency,
  }).format(amountMinor / 100);
}

export function dateTime(value?: string | null) {
  if (!value) return '—';
  return new Intl.DateTimeFormat('pt-PT', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}
